import {Component, HostListener, Inject, PLATFORM_ID, ViewChild, ViewEncapsulation} from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {Router} from "@angular/router";
import {LoginFormComponent} from "./login-form/login-form.component";
import {isPlatformBrowser} from '@angular/common';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginPageComponent {
  screenWidth: number;
  loading = false;
  errorText: string | boolean;

  constructor(
    private readonly _authService: AuthService,
    private readonly _router: Router,
    @Inject(PLATFORM_ID) private readonly platformId: Object
  ) {
    if (this._authService.isTokenValid()) {
      _router.navigate(['vote']).then();
    }
    if (isPlatformBrowser(platformId)) {
      this.screenWidth = window.innerWidth;
    }
  }

  @HostListener('window:resize', ['$event'])
  getScreenWidth(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.screenWidth = window.innerWidth;
    }
  }

  @ViewChild('loginForm')
  form: LoginFormComponent;

  goToCandidates(): void {
    this._router.navigate(['candidates']).then();
  }

  setError(error: string | boolean): void {
    this.errorText = error;
  }
}
